module.exports = __webpack_public_path__ + "static/media/s_v10_t1_1.c9b63558.mp3";